import styled from 'styled-components';

export const JobSection = styled.div`
  display: flex;
  min-width: 0;
  gap: 12px;
  @media (max-width: 767px) {
    flex-direction: column;
  }
  align-items: start;
  padding: 20px 0;

  .enhance-button {
    margin-left: 8px;
    cursor: pointer;
    color: var(--color-text-muted);

    &:hover {
      color: var(--color-accent);
    }
  }

  .enhance-disabled-button {
    margin-left: 8px;
    opacity: 0.3;
    color: var(--color-text-muted);
  }
`;
